import filterAssignment from './utils/filterAssignment';

const deleteAssignmentReducer = (state, action) => {
  if (action.status !== 'success') return state;

  const {
    payload: { assignment },
  } = action;
  const remainingAssignments = state.assignments.filter(
    filterAssignment(assignment)
  );

  return {
    ...state,
    assignments: remainingAssignments,
  };
};

export default deleteAssignmentReducer;
